module.exports = {"sectionName":"Drinks","sectionPath":"/drinks","color":"red","menuItems":[{"name":"Beer & Cider","price":4,"options":["Fuller's Frontier","Daura Damm","Cornish Orchards"]},{"name":"Cocktails","price":6,"options":["Botanic Garden","Tiki Mule","Margarita","Rubby Fizz"]},{"name":"Classics","price":2,"options":["ginger beer","orange or apple juice","Coke","lemonade"]},{"name":"","price":0,"ingredients":[]}]}


//////////////////
// WEBPACK FOOTER
// ./src/data/drinks.json
// module id = 73
// module chunks = 0